/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from '../../hooks'

/**
 * @function
 * @description AlertSuccess
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 24
  const viewBoxHeight = 24
  const [, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id="Group_1951" data-name="Group 1951" transform="translate(11702.399 13679)">
        <g id="Boundary" transform="translate(-11702.399 -13679)" fill="#0b5a02" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none"/>
          <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
        </g>
        <path id="Path_checkbox-marked-circle-outline" data-name="Path / checkbox-marked-circle-outline" d="M20,12a8.006,8.006,0,1,1-5.8-7.69l1.57-1.57A9.822,9.822,0,0,0,12,2,10,10,0,1,0,22,12M7.91,10.08,6.5,11.5,11,16,21,6,19.59,4.58,11,13.17Z" transform="translate(-11702.399 -13679)" fill={props.fill || '#0b5a02'} />
      </g>
    </svg>
  )
}
